export const mutations = {
  setCategory: (state, payload) => {
    state.category = payload;
  },
  setCategoryValue: (state, payload) => {
    state.categoryValue = payload;
  }
};
